import { render, staticRenderFns } from "./createEmailTemplate.vue?vue&type=template&id=c4b6949c&scoped=true&"
import script from "./createEmailTemplate.vue?vue&type=script&lang=js&"
export * from "./createEmailTemplate.vue?vue&type=script&lang=js&"
import style0 from "./createEmailTemplate.vue?vue&type=style&index=0&id=c4b6949c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b6949c",
  null
  
)

export default component.exports